import axios from 'axios'
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useToasts } from 'react-toast-notifications'
import { API } from "../../../helpers/constants";
import { changeDateFromSQL } from "../../../helpers/dates";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import useUserData from "../../../hooks/user/useUserData";
import { REGISTRATIONS } from '../locales/namespaces'

const useRegistration = ({ registrationId }) => {
	const LOCALE = window.BASE_LURL
	const { token } = useUserData()
	const { t } = useTranslation(REGISTRATIONS)
	const [loading, setLoading] = useState(false)
	const [registration, setRegistration] = useState({}) //καταχωρηση (header)
	const [projects, setProjects] = useState({}) //έργα
	const [users, setUsers] = useState([]) //εργοδηγοί
	const [workers, setWorkers] = useState([]) //Εργαζόμενοι
	const [projectWorks, setProjectWorks] = useState([]) //details
	
	useEffect(() => {
		if (!registrationId) {
			setLoading(true)
			axios({
				method: 'get',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/fts/project/work/create`
			}).then(res => {
				const data = res.data
				setProjects(data.projects);
				setUsers(data.foremen);
				setWorkers(data.workers);
				setLoading(false)
			}).catch(error => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
				setLoading(false)
			})
		} else {
			setLoading(true)
			axios({
				method: 'post',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/fts/project/work/edit/` + registrationId
			}).then(res => {
				const data = res.data
				setRegistration(data.work)
				setUsers(data.foremen);
				setWorkers(data.workers)
				if (data && data.work?.details.length > 0) {
					setProjectWorks(data.work?.details)
				}
				setLoading(false)
			}).catch(error => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
				setLoading(false)
			})
		}
		
	}, [])
	
	return {
		loading,
		registration, //header καταχωρηση
		projects, // έργα
		users, //εργοδηγοί
		workers, //Εργαζόμενοι
		projectWorks, // details καταχώρησης
	}
}

export default useRegistration